import {getUrl} from "../../../constants/urls";

export const inventoryReportsURL = getUrl("inventoryReports");

export const LIST_HEADERS = [
  "serial",
  "organization",
  "customer",
  "site",
  "location",
  "action",
  "user_by",
  "event_at",
];

export const SORTABLE_FIELDS = [
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Site",
    value: "site",
  },
  {
    label: "Location",
    value: "location",
  },
  {
    label: "Serial",
    value: "serial",
  },
  {
    label: "Organization",
    value: "organization",
  },
  {
    label: "User By",
    value: "user_by",
  },
  {
    label: "Action",
    value: "action",
  },
  {
    label: "Event At",
    value: "event_at",
    type: "date",
  },
];
